import { Component, ElementRef } from '@angular/core';
import { LayoutService } from "./service/app.layout.service";
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-sidebar',
    templateUrl: './app.sidebar.component.html'
})
export class AppSidebarComponent {
    // En producción no se muestra el entorno (decisión P1).
    envName = (environment as any).envName ?? '';
    constructor(public layoutService: LayoutService, public el: ElementRef) { }
}
